import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@mui/material';

import classes from './ExtractionCardHeader.module.css';

export function ExtractionCardHeader({
  actions,
}: {
  actions: React.ReactNode | undefined;
}) {
  return (
    <Box className={classes.header}>
      <Box className={classes.headerLeft}>
        <FontAwesomeIcon icon={faSparkles} className={classes.sparkleIcon} />
        <Typography className={classes.headerTitle}>
          Document Extractor
        </Typography>
      </Box>

      {actions}
    </Box>
  );
}
